/**
 * Classical Vedic remedy reference (graha shanti) for the seven Shadbala
 * grahas — deity, beeja mantra with its traditional japa count, gemstone,
 * fasting day and charity items per planet. This is fixed domain reference
 * data (like the gochara house themes), keyed off LIVE computed afflictions
 * from `getPlanetStrengths` — the API decides WHICH planets need support,
 * this book says WHAT the classical remedies for that planet are.
 */

export const REMEDY_BOOK = {
  Sun: {
    glyph: '☀️',
    deity: 'Lord Surya',
    mantra: 'Om Hram Hrim Hraum Sah Suryaya Namah',
    japa: '7,000 times',
    gemstone: 'Ruby (Manikya)',
    metal: 'Copper / Gold',
    day: 'Sunday',
    fasting: 'Fast on Sundays',
    charity: 'Donate wheat, jaggery or copper',
    practice: 'Offer water to the rising Sun (Surya Arghya) and recite Aditya Hridayam',
  },
  Moon: {
    glyph: '🌙',
    deity: 'Lord Shiva / Chandra',
    mantra: 'Om Shram Shrim Shraum Sah Chandraya Namah',
    japa: '11,000 times',
    gemstone: 'Pearl (Moti)',
    metal: 'Silver',
    day: 'Monday',
    fasting: 'Fast on Mondays',
    charity: 'Donate rice, milk or white cloth',
    practice: 'Worship Lord Shiva and keep water in a silver vessel overnight',
  },
  Mars: {
    glyph: '♂️',
    deity: 'Lord Hanuman / Mangala',
    mantra: 'Om Kram Krim Kraum Sah Bhaumaya Namah',
    japa: '10,000 times',
    gemstone: 'Red Coral (Moonga)',
    metal: 'Copper',
    day: 'Tuesday',
    fasting: 'Fast on Tuesdays',
    charity: 'Donate red lentils (masoor dal) or red cloth',
    practice: 'Recite Hanuman Chalisa on Tuesdays and Saturdays',
  },
  Mercury: {
    glyph: '☿',
    deity: 'Lord Vishnu / Budha',
    mantra: 'Om Bram Brim Braum Sah Budhaya Namah',
    japa: '9,000 times',
    gemstone: 'Emerald (Panna)',
    metal: 'Bronze',
    day: 'Wednesday',
    fasting: 'Fast on Wednesdays',
    charity: 'Donate green moong dal or green vegetables',
    practice: 'Recite Vishnu Sahasranama and feed green fodder to cows',
  },
  Jupiter: {
    glyph: '♃',
    deity: 'Lord Brihaspati / Dakshinamurthy',
    mantra: 'Om Gram Grim Graum Sah Gurave Namah',
    japa: '19,000 times',
    gemstone: 'Yellow Sapphire (Pukhraj)',
    metal: 'Gold',
    day: 'Thursday',
    fasting: 'Fast on Thursdays',
    charity: 'Donate turmeric, chana dal or yellow cloth',
    practice: 'Serve teachers and elders; apply a turmeric tilak on Thursdays',
  },
  Venus: {
    glyph: '♀',
    deity: 'Goddess Lakshmi / Shukra',
    mantra: 'Om Dram Drim Draum Sah Shukraya Namah',
    japa: '16,000 times',
    gemstone: 'Diamond (Heera) / White Sapphire',
    metal: 'Silver / Platinum',
    day: 'Friday',
    fasting: 'Fast on Fridays',
    charity: 'Donate white rice, curd, sugar or silver',
    practice: 'Recite Sri Suktam and treat women of the house with respect',
  },
  Saturn: {
    glyph: '♄',
    deity: 'Lord Shani / Hanuman',
    mantra: 'Om Pram Prim Praum Sah Shanaye Namah',
    japa: '23,000 times',
    gemstone: 'Blue Sapphire (Neelam)',
    metal: 'Iron',
    day: 'Saturday',
    fasting: 'Fast on Saturdays',
    charity: 'Donate black sesame, mustard oil, black cloth or iron',
    practice: 'Light a mustard-oil lamp under a Peepal tree on Saturday evenings',
  },
}

/** The remedy entry for a graha, or null for bodies without one (Rahu/Ketu etc.). */
export function remedyFor(planet) {
  return REMEDY_BOOK[planet] || null
}
